/**
 * Admin Users Management — Reuses the enhanced Staff Users component
 * with role-based access for admin/staff
 */
import React from "react";
import { RequireRole } from "@/lib/useUser";
import StaffUsers from "@/pages/staff/Users";

export default function AdminUsersManagement() {
  return (
    <RequireRole allowed={["admin", "staff"]}>
      <StaffUsers />
    </RequireRole>
  );
}
